import { call, put, takeEvery } from "redux-saga/effects"

import { GET_USER_MY_TEAM, UPDATE_USER_MY_TEAM } from "./actionTypes"

import { getUserMyTeamFailed, getUserMyTeamSuccessfull, updateUserMyTeamFailed, updateUserMyTeamSuccessfull } from "./actions"

import { updateUserDetailGet, updateUserDetailPost } from "../../../../helpers/fakebackend_helper"

//restapi end point
import * as constClass from "../../../../common/constant/constantURL"

// get candidate list
function* getUserDetails({payload:{updateUserIdMyteam}}) {
    try 
    {
      var url=constClass.REST_API_MYTEAM_UPDATE_USER_GET;
      var responsJSON = yield call(updateUserDetailGet, url+"?userId="+updateUserIdMyteam);
      yield put(getUserMyTeamSuccessfull(responsJSON))
    } 
    catch (error) 
    {
      yield put(getUserMyTeamFailed(error))
    }
  }

  function* setUpdateUser({ payload: { userMyTeam } }) {
    try 
    {
      var url=constClass.REST_API_MYTEAM_UPDATE_USER_POST;
      var jsonResponse = yield call(updateUserDetailPost, url, userMyTeam);
      yield put(updateUserMyTeamSuccessfull(jsonResponse.message));
    } 
    catch (error) 
    {
      yield put(updateUserMyTeamFailed(error))
    }
  }

  function* getUpdateUserSaga() {
    yield takeEvery (GET_USER_MY_TEAM, getUserDetails);
    yield takeEvery (UPDATE_USER_MY_TEAM, setUpdateUser);
  }
  
  export default getUpdateUserSaga